import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(3 3)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M18 18.75H0V17.25H18V18.75ZM9.75 12.1895L14.4697 7.46973L15.5303 8.53027L9.53027 14.5303C9.38962 14.6709 9.19891 14.75 9 14.75C8.80109 14.75 8.61038 14.6709 8.46973 14.5303L2.46973 8.53027L3.53027 7.46973L8.25 12.1895V0H9.75V12.1895Z",
			fill: "currentColor"
		})
	})
});
export default SvgDownload;
